





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Magazine from '@/models/Magazine';

const MagazineStore = namespace('magazine');
const ApplicationStore = namespace('application');

@Component({
    components: {
        ThumbnailPageComponent: () => import(
            /* webpackChunkName: "ThumbnailPageComponent" */
            '@/components/reader/ThumbnailPage.component.vue'),
        AccessibilityButtonComponent: () => import(
            /* webpackChunkName: "AccessibilityButtonComponent" */
            '@/components/shared/AccessibilityButton.component.vue')
    }
})
export default class ThumbnailComponent extends Vue {

    @Prop({ default: false })
    public splitMode!: boolean;

    @Prop({ default: false })
    public show!: boolean;

    @Prop({ default: 0 })
    public currentPage!: number;

    @MagazineStore.Getter('selectedMagazine')
    private selectedMagazine!: Magazine;

    @ApplicationStore.Getter('accessibilityControls')
    private _accessibilityControls!: boolean;

    @ApplicationStore.Getter('noAnimations')
    private noAnimations!: boolean;

    get accessibilityControls(): boolean {
        return this._accessibilityControls;
    }

    public isSliding: boolean = false;

    public openThumbnailPage(page: number) {
        if (!this.isSliding) {
            this.$emit('thumbnailClicked', page);
        }
    }

    /**
     * if thumbnail is shown
     * center the current page in the thumbnail
     */
    public updated() {
        if (this.show) {
            // get selectedPage
            const selectedPage = document.getElementById(this.currentPage.toString());
            if (!this.splitMode && selectedPage) {
                selectedPage.scrollIntoView({ inline: 'center' });
            } else if (this.splitMode && selectedPage) {
                // set neighbour page id
                const neighbourId = this.currentPage + 1;
                const neighbourPage = document.getElementById(neighbourId.toString());

                // to center two sided page wie need to calculate the differnece offset
                let difference = 0;

                // calculate difference to put two pages in the middle
                if (neighbourPage && selectedPage && this.currentPage > 0) {
                    difference = (neighbourPage.offsetLeft - selectedPage.offsetLeft) / 2;
                }

                // center selected page
                selectedPage.scrollIntoView({ inline: 'center' });
                // scroll the last differnece to center thumbnail
                (this.$refs.scrollContainer as any).scrollBy({
                    top: 0,
                    left: difference
                });
            }
        }
    }

    /**
     * check if given thumbnail is next to currentPage should be highlighted
     * @param pageNumber
     */
    private isNextPage(pageNumber: number): boolean {
        return pageNumber === (this.currentPage + 1) && pageNumber % 2 === 0;

    }

    public created() {
        setTimeout(() => {
            this.initThumbnailScroll();
        }, 100);
    }

    public scrollLeft() {
        (this.$refs.scrollContainer as any).scrollBy({
            top: 0,
            left: -175,
            behavior: 'smooth'
        });
    }

    public scrollRight() {
        (this.$refs.scrollContainer as any).scrollBy({
            top: 0,
            left: 175,
            behavior: 'smooth'
        });
    }

    get scrollContainer(): HTMLElement {
        return (this.$refs.scrollContainer as HTMLDivElement)!;
    }

    public initThumbnailScroll() {
        const slider = this.scrollContainer;
        let isDown = false;
        let startX: any;
        let scrollLeft: any;

        if (slider) {
            slider.addEventListener('mousedown', (e: any) => {
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });

            slider.addEventListener('mouseleave', () => {
                isDown = false;
                this.isSliding = false;
            });

            slider.addEventListener('mouseup', () => {
                isDown = false;
                setTimeout(() => { // Small delay to not trigger the open page event
                    this.isSliding = false;
                }, 100);
            });

            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return; // Check if the mouse was clicked before moving the slider
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = x - startX;
                slider.scrollLeft = scrollLeft - walk;
                this.isSliding = true;
            });
        }
    }
};
